import "bootstrap";
import jquery from "jquery";
import { log } from "../../commons";
window.$ = window.jQuery = jquery;
export function loadFromLS(id) {
    try {
        const stateStr = localStorage.getItem(`KPCURSEDTABLE_${id}`);
        return stateStr ? JSON.parse(stateStr) : {};
    }
    catch (e) {
        log(e);
        return {};
    }
}
export function saveFromLS(id, state) {
    try {
        localStorage.setItem(`KPCURSEDTABLE_${id}`, JSON.stringify(state[id] || {}));
    }
    catch (e) {
        log(e);
    }
    return state;
}
